import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=f7f9c49e&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=ts"
export * from "./SwitchToggle.vue?vue&type=script&lang=ts"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=f7f9c49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f9c49e",
  null
  
)

export default component.exports